<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M2.375 9.29586H21.625C22.3844 9.29586 23 9.9115 23 10.6709V21.6709C23 22.4302 22.3844 23.0459 21.625 23.0459H2.375C1.61563 23.0459 1 22.4302 1 21.6709V10.6709C1 9.9115 1.61563 9.29586 2.375 9.29586Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.5 4L6 9" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
    <path d="M22.6589 9.76495L19.7815 1.85925C19.5218 1.14562 18.7327 0.777719 18.0192 1.03746L2.5142 6.68078C1.80062 6.94051 1.43272 7.72954 1.69241 8.44311L2.01971 9.34241" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.75 12.0458H8.33333V14.7958H3.75V12.0458Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.75 17.5458H5.58333" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.75 20.2958H8.33333" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.33334 17.5458H10.1667" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.9167 17.5458H14.75" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.5 17.5458H19.3333" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
